import { Skeleton } from "primereact/skeleton";

const TimesheetSkeleton = () => {
    const ITEM_COUNT = 4;

    const getItems = () => {
        const items = [];
        for (let i = 0; i < ITEM_COUNT; i++) {
            items.push(
                <Skeleton key={i} className="w-full" height="7rem" />
            );
        }
        return items;
    };

    return (
        <div className="flex flex-column pt-5 px-3 gap-3 pb-6 align-items-center h-full">
            <div className="w-full flex-column flex justify-content-center gap-3">
                {getItems()}
            </div>
        </div>
    );
};

export default TimesheetSkeleton;